<template>
  <navigation v-if="!isAdminRoute" />
  <router-view />
  <footerVue v-if="!isAdminRoute" />
  <transition name="cart-desktop-bubble-fade">
    <div
      v-if="!isAdminRoute && showDesktopCartBubble && desktopCartCount > 0"
      class="desktop-cart-bubble div-none-movil"
      aria-live="polite"
      role="status"
      @click="openDesktopCartBubble"
    >
      <svg viewBox="0 0 24 24" class="desktop-cart-bubble-icon" aria-hidden="true">
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
      </svg>
      <span class="desktop-cart-bubble-count">{{ desktopCartCount }}</span>
    </div>
  </transition>
  <div v-if="!isAdminRoute" class="enlace_chat div-none-movil">
    <a
      id="wasap"
      href="https://api.whatsapp.com/send?phone=573228463663"
      target="_blank"
      ><img
        class="enlace_chat_wasap"
        src="./assets/PNGs/Whatsapp.png"
        alt="whasap"
    /></a>
    <img
      @click="chatVisibility()"
      src="./assets/PNGs/Group1778.png"
      alt="Chat"
    />
    <span v-if="token_countMessage_total !== 0" class="spanCountChatAdviser">{{
      token_countMessage_total
    }}</span>
  </div>
  <div v-if="!isAdminRoute" class="button-top display-none-desk">
    <img @click="topMax()" src="./assets/PNGs/Vector_11.png" alt="" />
  </div>
  <Chat v-if="!isAdminRoute" id="chat-oculto" />
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapActions, mapState } from "vuex";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";
import Cart from "./modules/Catalogue/Cart.vue";
export default {
  name: "App",
  components: {
    navigation: defineAsyncComponent(() =>
      import(/* webpackChunkName: "navigation" */ "@/navigation/navigation")
    ),
    footerVue: defineAsyncComponent(() =>
      import(/* webpackChunkName: "footerVue" */ "./modules/footer/footer.vue")
    ),
    Chat: defineAsyncComponent(() =>
      import(/* webpackChunkName: "chat" */ "./modules/chat/chat.vue")
    ),
    Cart,
  },
  data() {
    return {
      token_countMessage_total: 0,
      desktopCartCount: 0,
      showDesktopCartBubble: false,
      onDesktopCartUpdated: null,
    };
  },
  computed: {
    ...mapState(["chats"]),
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    }
  },

  mounted() {
    this.ensureBodyCanScroll();
    window.addEventListener("resize", this.ensureBodyCanScroll, { passive: true });

    this.desktopCartCount = this.getCartTotalItems();
    this.showDesktopCartBubble = window.innerWidth >= 1200 && this.desktopCartCount > 0;
    this.onDesktopCartUpdated = () => {
      const nextCount = this.getCartTotalItems();

      this.desktopCartCount = nextCount;
      this.showDesktopCartBubble = window.innerWidth >= 1200 && nextCount > 0;
    };

    window.addEventListener("cart-updated", this.onDesktopCartUpdated);

    var lastScrollPosition = 0;
    var threshold = 200;
    window.addEventListener("scroll", function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var scrollDistance = scrollTop - lastScrollPosition;
      const elemento = document.querySelector("#wasap");
      if (Math.abs(scrollDistance) >= threshold) {
        if (document.querySelector(".wasap_hover")) {
          elemento.classList.remove("wasap_hover");
        }
        lastScrollPosition = scrollTop;
      }
    });

    if (window.innerWidth >= 1200) {
      const elementoHover = document.querySelector(".enlace_chat");
      const elemento = document.querySelector("#wasap");

      elementoHover.addEventListener("mouseover", function () {
        elemento.classList.add("wasap_hover");
      });
      elementoHover.addEventListener("mouseout", function () {
        elemento.classList.remove("wasap_hover");
      });
    }
  },
  methods: {
    ...mapActions(["loadChat"]),
    ensureBodyCanScroll() {
      const hasBlockingOverlay = document.querySelector(
        ".navigatiom-visibility, .modal-visible, .cart-modal-bg"
      );
      if (!hasBlockingOverlay) {
        document.body.style.overflow = "auto";
      }
    },
    getCartTotalItems() {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      return cart.reduce((sum, item) => sum + Number(item.quantity || 1), 0);
    },
    chatVisibility() {
      if (window.innerWidth <= 1200) {
        const elemento = document.querySelector("#wasap");

        if (!document.querySelector(".wasap_hover")) {
          elemento.classList.add("wasap_hover");
        } else {
          elemento.classList.remove("wasap_hover");
          const element = document.querySelector("#chat-oculto");
          if (document.querySelector(".chat-visible")) {
            element.classList.remove("chat-visible");
          } else {
            element.classList.add("chat-visible");
          }
          let token_countMessage_1 = parseInt(
            localStorage.getItem("token_countMessage_1")
          );
          localStorage.setItem("token_countMessage_2", token_countMessage_1);
          localStorage.setItem("token_countMessage_total", 0);
          this.token_countMessage_total = parseInt(
            localStorage.getItem("token_countMessage_total")
          );
        }
      } else {
        const element = document.querySelector("#chat-oculto");
        if (document.querySelector(".chat-visible")) {
          element.classList.remove("chat-visible");
        } else {
          element.classList.add("chat-visible");
        }
        let token_countMessage_1 = parseInt(
          localStorage.getItem("token_countMessage_1")
        );
        localStorage.setItem("token_countMessage_2", token_countMessage_1);
        localStorage.setItem("token_countMessage_total", 0);
        this.token_countMessage_total = parseInt(
          localStorage.getItem("token_countMessage_total")
        );
      }
    },
    openDesktopCartBubble() {
      window.dispatchEvent(new Event("open-cart-modal"));
    },
    getRandomId() {
      const timestamp = Date.now().toString();
      const uniqueId = timestamp;
      return uniqueId;
    },
    countChatAdviser_1() {
      setTimeout(() => {
        let countMessage = 0;
        const values = Object.values(this.chats);
        for (let i = values.length - 1; i > 0; i--) {
          const chatObj = values[i];
          if (chatObj.typeUser === "adviser") {
            countMessage++;
          } else {
            break;
          }
        }
        localStorage.setItem("token_countMessage_1", countMessage);
      }, 500);
    },

    topMax() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    countChatAdviser_2() {
      if (!localStorage.getItem("token_countMessage_2")) {
        localStorage.setItem("token_countMessage_2", 0);
      }
    },

    countChatAdviserTotal() {
      setTimeout(() => {
        if (!document.querySelector(".chat-visible")) {
          let token_countMessage_1 = parseInt(
            localStorage.getItem("token_countMessage_1")
          );
          let token_countMessage_2 = parseInt(
            localStorage.getItem("token_countMessage_2")
          );
          let token_countMessage_total =
            token_countMessage_1 - token_countMessage_2;
          localStorage.setItem(
            "token_countMessage_total",
            token_countMessage_total
          );
          this.token_countMessage_total = parseInt(
            localStorage.getItem("token_countMessage_total")
          );
        } else {
          let token_countMessage_1 = parseInt(
            localStorage.getItem("token_countMessage_1")
          );
          localStorage.setItem("token_countMessage_2", token_countMessage_1);
        }
      }, 600);
    },

    load() {
      const firebaseConfig = {
        apiKey: "AIzaSyD8Ghlq7sioz4TRmstCXVltpcnfkRiX8UE",
        authDomain: "wimportaciones-b7da1.firebaseapp.com",
        databaseURL: "https://wimportaciones-b7da1-default-rtdb.firebaseio.com",
        projectId: "wimportaciones-b7da1",
        storageBucket: "wimportaciones-b7da1.appspot.com",
        messagingSenderId: "964574639089",
        appId: "1:964574639089:web:48f040e9899b8dbcdb4a50",
        measurementId: "G-JF7XP4SMVB",
      };
      const app = initializeApp(firebaseConfig);
      const database = getDatabase();
      const dataRef = ref(database, "chat");
      onValue(dataRef, (snapshot) => {
        this.loadChat();
        this.countChatAdviser_1();
        this.countChatAdviserTotal();
      });
    },
  },

  created() {
    this.load();
    this.countChatAdviser_2();
    if (!localStorage.getItem("token_chat")) {
      localStorage.setItem("token_chat", this.getRandomId());
    }
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.ensureBodyCanScroll);
    if (this.onDesktopCartUpdated) {
      window.removeEventListener("cart-updated", this.onDesktopCartUpdated);
    }
  },

  watch: {
    $route() {
      this.$nextTick(() => {
        this.ensureBodyCanScroll();
      });
    },
  },
};
</script>

<style>
.desktop-cart-bubble {
  position: fixed;
  right: 4.2rem;
  bottom: 13.2rem;
  width: 5.6rem;
  height: 5.6rem;
  border-radius: 50%;
  background: #ffffff;
  border: 1.5px solid #005bea;
  color: #005bea;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 18px rgba(0, 91, 234, 0.14);
  z-index: 1002;
  pointer-events: auto;
  cursor: pointer;
}

.desktop-cart-bubble-icon {
  width: 2.4rem;
  height: 2.4rem;
  fill: currentColor;
}

.desktop-cart-bubble-count {
  position: absolute;
  top: -0.4rem;
  right: -0.4rem;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.5rem;
  border-radius: 999px;
  background: #e53935;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.22);
}

.cart-desktop-bubble-fade-enter-active,
.cart-desktop-bubble-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.cart-desktop-bubble-fade-enter-from,
.cart-desktop-bubble-fade-leave-to {
  opacity: 0;
  transform: translateY(1rem) scale(0.94);
}

@media screen and (max-width: 1199px) {
  .desktop-cart-bubble {
    display: none !important;
  }
}
</style>
